module.exports = __webpack_public_path__ + "assets/5-sales-recruiter.ef68f3aa.png";